// Determines regional discount from the visitor's country (the fullstack's /api/v1/country: the
// IP's country from Vercel's header), falling back to the browser's time zone.
// Uses country income data and caches results to minimize lookups.

const log = (msg) => process.env.VUE_APP_DEV && console.log(); // eslint-disable-line
import codeByTimeZone from "/src/assets/general/country-code-by-time-zone.json";
import incomeCategories from "/src/assets/general/income-by-country-code.json";
import {getFullstackUrl} from "/src/composables/useFullstackUrl";
let discount = null; // use this variable to remember previous calls

const discounts = {
  "Low income": 0.95,
  "Lower middle income": 0.8,
  "Upper middle income": 0.4,
  "High income": 0
};

async function fetchCountryByIP() {
  try {
    const response = await fetch(`${getFullstackUrl()}/api/v1/country`);
    const data = await response.json();
    return data.country || "";
  } catch (error) {
    log("IP lookup failed: " + error);
    return "";
  }
}

function fetchCountryByBrowserSettings() {
  if (!Intl) return "";
  let region = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return codeByTimeZone[region] || "";
}

export async function useRegionalDiscount() {
  if (discount !== null) return discount; // return if already determined
  let country = await fetchCountryByIP();
  if (!country) country = fetchCountryByBrowserSettings();
  log(`useRegionalDiscount: country = ${country}`);
  const category = incomeCategories[country] || "High income";
  log(`useRegionalDiscount: category = ${category}`);
  discount = discounts[category] || 0;
  log(`useRegionalDiscount: discount = ${discount}`);
  return discount;
}

// the visitor is in a low-income country (the 2026 FAQ's fees answer; Seán, 2026-10-22)
export async function fetchIsLowIncome() {
  return (await useRegionalDiscount()) === discounts["Low income"];
}

// the visitor's Regional Rate as a multiplier of the high-income fee (1, 0.6, 0.2, 0.05), as the
// fullstack's (shared/registration/feeRules.js MULTIPLIER_BY_INCOME; the 2026 FAQ's saving)
export async function fetchRegionalMultiplier() {
  return Math.round((1 - (await useRegionalDiscount())) * 100) / 100;
}
